import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import { kebabCase, pascalCase, snakeCase } from 'change-case';
export { camelCase, pascalCase, snakeCase } from 'change-case';
import _regenerator from '@babel/runtime/helpers/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import isObject from 'lodash/isObject';
import { useEffect, useMemo } from 'react';
import tinycolor from 'tinycolor2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import isArray from 'lodash/isArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import slugify from 'slugify';

function addNonBreakingSpaces(text) {
  return isString(text) ? text.replace(/«\s/g, '« ').replace(/\s»/g, ' »').replace(/\s:\s/g, ' : ') : text;
}

var convertStyleToString = function convertStyleToString(style) {
  return style !== null ? Object.keys(style).map(function (key) {
    return "".concat(kebabCase(key), ":").concat(isNumber(style[key]) ? "".concat(style[key], "px") : style[key], ";");
  }).join('\n') : '';
};

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

// @note vendoring this: https://github.com/feross/clipboard-copy/blob/master/index.js
// we might want to add that to the npm deps and just use it

function makeError() {
  return new DOMException('The request is not allowed', 'NotAllowedError');
}
function copyClipboardApi(_x) {
  return _copyClipboardApi.apply(this, arguments);
}
function _copyClipboardApi() {
  _copyClipboardApi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(text) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (navigator.clipboard) {
            _context.n = 1;
            break;
          }
          throw makeError();
        case 1:
          return _context.a(2, navigator.clipboard.writeText(text));
      }
    }, _callee);
  }));
  return _copyClipboardApi.apply(this, arguments);
}
function copyExecCommand(_x2) {
  return _copyExecCommand.apply(this, arguments);
}
function _copyExecCommand() {
  _copyExecCommand = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(text) {
    var span, selection, range, success;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          // Put the text to copy into a <span>
          span = document.createElement('span');
          span.textContent = text;

          // Preserve consecutive spaces and newlines
          span.style.whiteSpace = 'pre';
          span.style.webkitUserSelect = 'auto';
          span.style.userSelect = 'all';

          // Add the <span> to the page
          document.body.appendChild(span);

          // Make a selection object representing the range of text selected by the user
          selection = window.getSelection();
          range = window.document.createRange();
          selection.removeAllRanges();
          range.selectNode(span);
          selection.addRange(range);

          // Copy text to the clipboard
          success = false;
          try {
            success = window.document.execCommand('copy');
          } finally {
            // Cleanup
            selection.removeAllRanges();
            window.document.body.removeChild(span);
          }
          if (success) {
            _context2.n = 1;
            break;
          }
          throw makeError();
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _copyExecCommand.apply(this, arguments);
}
function copyToClipboard(_x3) {
  return _copyToClipboard.apply(this, arguments);
}
function _copyToClipboard() {
  _copyToClipboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(text) {
    var _t, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return copyClipboardApi(text);
        case 1:
          _context3.n = 6;
          break;
        case 2:
          _context3.p = 2;
          _t = _context3.v;
          _context3.p = 3;
          _context3.n = 4;
          return copyExecCommand(text);
        case 4:
          _context3.n = 6;
          break;
        case 5:
          _context3.p = 5;
          _t2 = _context3.v;
          throw _t2 || _t || makeError();
        case 6:
          return _context3.a(2);
      }
    }, _callee3, null, [[3, 5], [0, 2]]);
  }));
  return _copyToClipboard.apply(this, arguments);
}

var createNullableOnChange = function createNullableOnChange() {
  var onChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (newValue) {
    var nullableValue = newValue;
    if (isObject(newValue)) {
      var allNull = Object.keys(newValue).reduce(function (acc, key) {
        return acc && newValue[key] === null;
      }, true);
      if (allNull) {
        nullableValue = null;
      }
    }
    if (onChange !== null) {
      onChange(nullableValue);
    }
  };
};

var createUseEvent = function createUseEvent(eventsManager) {
  return function (event, callback) {
    var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    useEffect(function () {
      if (enabled && eventsManager !== null) {
        eventsManager.subscribe(event, callback);
      }
      return function () {
        if (enabled && eventsManager !== null) {
          eventsManager.unsubscribe(event, callback);
        }
      };
    }, [eventsManager, event, callback, enabled]);
  };
};

/* eslint-disable */
var easings = {
  linear: function linear(x) {
    return x;
  },
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  easeOutQuad: function easeOutQuad(x) {
    return 1 - (1 - x) * (1 - x);
  },
  easeInOutQuad: function easeInOutQuad(x) {
    return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
  },
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  easeOutCubic: function easeOutCubic(x) {
    return 1 - Math.pow(1 - x, 3);
  },
  easeInOutCubic: function easeInOutCubic(x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  },
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  easeOutQuart: function easeOutQuart(x) {
    return 1 - Math.pow(1 - x, 4);
  },
  easeInOutQuart: function easeInOutQuart(x) {
    return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
  },
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  easeOutQuint: function easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
  },
  easeInOutQuint: function easeInOutQuint(x) {
    return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
  },
  easeInSine: function easeInSine(x) {
    return 1 - Math.cos(x * Math.PI / 2);
  },
  easeOutSine: function easeOutSine(x) {
    return Math.sin(x * Math.PI / 2);
  },
  easeInOutSine: function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
  },
  easeInExpo: function easeInExpo(x) {
    return x === 0 ? 0 : Math.pow(2, 10 * x - 10);
  },
  easeOutExpo: function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  },
  easeInOutExpo: function easeInOutExpo(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2;
  },
  easeInCirc: function easeInCirc(x) {
    return 1 - Math.sqrt(1 - Math.pow(x, 2));
  },
  easeOutCirc: function easeOutCirc(x) {
    return Math.sqrt(1 - Math.pow(x - 1, 2));
  },
  easeInOutCirc: function easeInOutCirc(x) {
    return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
  },
  easeInBack: function easeInBack(x) {
    return c3 * x * x * x - c1 * x * x;
  },
  easeOutBack: function easeOutBack(x) {
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
  },
  easeInOutBack: function easeInOutBack(x) {
    return x < 0.5 ? Math.pow(2 * x, 2) * ((c2 + 1) * 2 * x - c2) / 2 : (Math.pow(2 * x - 2, 2) * ((c2 + 1) * (x * 2 - 2) + c2) + 2) / 2;
  },
  easeInElastic: function easeInElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * c4);
  },
  easeOutElastic: function easeOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
  },
  easeInOutElastic: function easeInOutElastic(x) {
    return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5) / 2 + 1;
  }
};

var getColorAsString = function getColorAsString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var overideAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (value === null) {
    return null;
  }
  var _ref = isString(value) ? {
      color: value
    } : value,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? null : _ref$color,
    _ref$alpha = _ref.alpha,
    alpha = _ref$alpha === void 0 ? null : _ref$alpha;
  return alpha !== null || overideAlpha !== null ? tinycolor(color).setAlpha(overideAlpha !== null ? overideAlpha : alpha).toRgbString() : color;
};

var getComponentFromName = function getComponentFromName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var components = arguments.length > 1 ? arguments[1] : undefined;
  var defaultComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (components === null || name === null) {
    return defaultComponent;
  }
  var pascalName = pascalCase(name);
  return components[pascalName] || components[name] || defaultComponent;
};

var deviceScreens = [{
  name: 'mobile'
}, {
  name: 'small',
  mediaQuery: 'only screen and (min-width: 500px)'
}, {
  name: 'medium',
  mediaQuery: 'only screen and (min-width: 790px)'
}, {
  name: 'large',
  mediaQuery: 'only screen and (min-width: 1000px)'
}, {
  name: 'very-large',
  mediaQuery: 'only screen and (min-width: 1600px)'
}];

// eslint-disable-next-line import/prefer-default-export
var getDeviceScreens = function getDeviceScreens() {
  return deviceScreens;
};

var getDisplayName = function getDisplayName(_ref) {
  var _ref$displayName = _ref.displayName,
    displayName = _ref$displayName === void 0 ? null : _ref$displayName,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name;
  return displayName || name || 'Component';
};

var _getFieldByName = function getFieldByName(fields, name) {
  return fields.reduce(function (foundField, it) {
    if (foundField !== null) {
      return foundField;
    }
    var _it$name = it.name,
      fieldName = _it$name === void 0 ? null : _it$name,
      _it$fields = it.fields,
      subFields = _it$fields === void 0 ? [] : _it$fields;
    if (name !== null && fieldName === name) {
      return it;
    }
    return _getFieldByName(subFields, name);
  }, null);
};

var getFieldFromPath = function getFieldFromPath(path, fields, fieldManager) {
  return (isArray(path) ? path : [path]).reduce(function (foundField, key) {
    if (foundField === null) {
      return null;
    }
    var _foundField$type = foundField.type,
      type = _foundField$type === void 0 ? null : _foundField$type,
      _foundField$fields = foundField.fields,
      fieldFields = _foundField$fields === void 0 ? null : _foundField$fields,
      _foundField$field = foundField.field,
      field = _foundField$field === void 0 ? null : _foundField$field,
      _foundField$itemsFiel = foundField.itemsField,
      itemsField = _foundField$itemsFiel === void 0 ? null : _foundField$itemsFiel;
    var finalType = field !== null ? field.type || type : type;
    var definition = fieldManager.getDefinition(finalType);
    var _ref = finalType !== null ? definition : foundField,
      _ref$fields = _ref.fields,
      subFields = _ref$fields === void 0 ? null : _ref$fields,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? null : _ref$settings,
      _ref$itemsField = _ref.itemsField,
      defItemsField = _ref$itemsField === void 0 ? null : _ref$itemsField;
    var finalItemsField = itemsField || defItemsField;
    if (finalItemsField !== null && key.match(/^[0-9]+$/)) {
      return _objectSpread(_objectSpread({}, finalItemsField), {}, {
        name: path.join('/'),
        listItems: true
      });
    }
    return _getFieldByName([].concat(_toConsumableArray(fieldFields || []), _toConsumableArray(subFields || []), _toConsumableArray(settings || [])), key);
  }, {
    fields: fields
  });
};

var getFileName = function getFileName() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (url === null || typeof url.match === 'undefined') {
    return null;
  }
  return url.match(/([^/]+)(\?.*)?$/)[1] || url;
};

var getFontFamily = function getFontFamily(value) {
  if (value == null) {
    return null;
  }
  var _ref = isObject(value) ? value : {
      name: value
    },
    name = _ref.name,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  return [name, fallback].filter(function (it) {
    return it !== null;
  }).map(function (it) {
    return "\"".concat(it, "\"");
  }).join(', ');
};

var _excluded$1 = ["isPreview", "isView", "current", "openWebView", "enableInteraction", "disableInteraction"];
var getFooterProps = function getFooterProps() {
  var footer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$isPreview = _ref.isPreview,
    isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
    _ref$isView = _ref.isView,
    isView = _ref$isView === void 0 ? false : _ref$isView,
    _ref$current = _ref.current,
    current = _ref$current === void 0 ? false : _ref$current,
    _ref$openWebView = _ref.openWebView,
    openWebView = _ref$openWebView === void 0 ? false : _ref$openWebView,
    _ref$enableInteractio = _ref.enableInteraction,
    enableInteraction = _ref$enableInteractio === void 0 ? true : _ref$enableInteractio,
    _ref$disableInteracti = _ref.disableInteraction,
    disableInteraction = _ref$disableInteracti === void 0 ? false : _ref$disableInteracti,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  var _ref2 = footer || {},
    _ref2$callToAction = _ref2.callToAction,
    callToAction = _ref2$callToAction === void 0 ? null : _ref2$callToAction;
  var footerProps = useMemo(function () {
    return {
      callToAction: _objectSpread(_objectSpread({}, callToAction), {}, {
        animationDisabled: isPreview,
        focusable: current && isView,
        openWebView: openWebView,
        enableInteraction: enableInteraction,
        disableInteraction: disableInteraction
      }, otherProps)
    };
  }, [callToAction, isPreview, isView, current, enableInteraction, disableInteraction, otherProps]);
  return footerProps;
};

var getGridLayoutName = function getGridLayoutName(layout) {
  return layout.map(function (it) {
    return "".concat(it.rows, "_").concat(it.columns.join('_'));
  }).join('|');
};

var getRemainder = function getRemainder(number) {
  var remainder = number - Math.floor(number);
  return remainder.toFixed(4);
};
var largestRemainderRound = function largestRemainderRound(numbers, desiredTotal) {
  if (!isArray(numbers) || numbers.length < 1) return numbers;
  var result = numbers.map(function (number, index) {
    return {
      floor: Math.floor(number) || 0,
      remainder: getRemainder(number),
      index: index
    };
  }).sort(function (a, b) {
    return b.remainder - a.remainder;
  });
  var lowerSum = result.reduce(function (sum, current) {
    return sum + current.floor;
  }, 0);
  var delta = desiredTotal - lowerSum;
  for (var i = 0; i < delta; i += 1) {
    if (result[i]) {
      result[i].floor += 1;
    }
  }
  return result.sort(function (a, b) {
    return a.index - b.index;
  }).map(function (res) {
    return res.floor;
  });
};

var _excluded = ["image", "video", "media", "color"];
var getLayersFromBackground = function getLayersFromBackground() {
  var background = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (background === null) {
    return [];
  }
  return (isArray(background) ? background : [background]).reduce(function (layers, _ref) {
    var _ref$image = _ref.image,
      image = _ref$image === void 0 ? null : _ref$image,
      _ref$video = _ref.video,
      video = _ref$video === void 0 ? null : _ref$video,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? null : _ref$media,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? null : _ref$color,
      data = _objectWithoutProperties(_ref, _excluded);
    if (image === null && video === null && color === null) {
      return layers;
    }
    if (image !== null && video !== null) {
      return [].concat(_toConsumableArray(layers), [_objectSpread({
        media: image
      }, data), _objectSpread({
        media: video,
        color: color
      }, data)]);
    }
    return [].concat(_toConsumableArray(layers), [_objectSpread({
      media: media || image || video,
      color: color
    }, data)]);
  }, []);
};

var getMediaFilesAsArray = function getMediaFilesAsArray(files) {
  return files !== null && isArray(files) ? files : Object.keys(files || {}).reduce(function (newFiles, key) {
    return [].concat(_toConsumableArray(newFiles), [_objectSpread({
      handle: key
    }, files[key])]);
  }, []);
};

// eslint-disable-next-line import/prefer-default-export
var getOptimalImageUrl = function getOptimalImageUrl() {
  var media = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var containerWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var containerHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$resolution = _ref.resolution,
    resolution = _ref$resolution === void 0 ? 1 : _ref$resolution,
    _ref$maxDiff = _ref.maxDiff,
    maxDiff = _ref$maxDiff === void 0 ? 800 : _ref$maxDiff;
  var _ref2 = media || {},
    _ref2$sizes = _ref2.sizes,
    sizes = _ref2$sizes === void 0 ? null : _ref2$sizes,
    _ref2$url = _ref2.url,
    defaultUrl = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$metadata = _ref2.metadata,
    _ref2$metadata2 = _ref2$metadata === void 0 ? {} : _ref2$metadata,
    imgWidth = _ref2$metadata2.width,
    imgHeight = _ref2$metadata2.height;
  if (sizes === null || containerWidth === null && containerHeight === null) {
    return defaultUrl;
  }
  var finalSizes = _objectSpread({
    original: {
      url: defaultUrl,
      width: imgWidth,
      height: imgHeight
    }
  }, sizes);
  var finalContainerWidth = containerWidth !== null && resolution !== null ? containerWidth * resolution : containerWidth;
  var finalContainerHeight = containerHeight !== null && resolution !== null ? containerHeight * resolution : containerHeight;
  var _Object$keys$reduce = Object.keys(finalSizes).reduce(function (acc, key) {
      var currentDiff = acc.diff,
        currentIsLarger = acc.isLarger,
        currentSize = acc.size;
      var _finalSizes$key = finalSizes[key],
        url = _finalSizes$key.url,
        _finalSizes$key$width = _finalSizes$key.width,
        width = _finalSizes$key$width === void 0 ? null : _finalSizes$key$width,
        _finalSizes$key$heigh = _finalSizes$key.height,
        height = _finalSizes$key$heigh === void 0 ? null : _finalSizes$key$heigh;
      var diffWidth = width !== null && finalContainerWidth !== null ? width - finalContainerWidth : null;
      var diffHeight = height !== null && finalContainerHeight !== null ? height - finalContainerHeight : null;
      var isLarger = (diffWidth === null || diffWidth >= 0) && (diffHeight === null || diffHeight >= 0);
      var diff = [diffWidth, diffHeight].reduce(function (total, value) {
        return value !== null ? (total || 0) + Math.abs(value) : total;
      }, null);
      if (diff === null) {
        diff = Infinity;
      }
      var size = (width || 0) + (height || 0);
      var sizeIsLarger = size > currentSize;
      if (
      // Difference is lower and image is larger
      diff < currentDiff && isLarger ||
      // Difference is lower and current is not larger or diff is greater than max
      diff < currentDiff && (!currentIsLarger && sizeIsLarger || currentDiff > maxDiff) ||
      // Image is larger and diff is smaller than max
      diff <= maxDiff && !currentIsLarger && isLarger ||
      // Image is larger than previous
      diff <= maxDiff && !currentIsLarger && !isLarger && sizeIsLarger) {
        return {
          key: key,
          url: url,
          diff: diff,
          isLarger: isLarger
        };
      }
      return acc;
    }, {
      key: null,
      url: defaultUrl,
      diff: Infinity,
      isLarger: false,
      size: 0
    }),
    finalUrl = _Object$keys$reduce.url;
  return finalUrl;
};

var getSecondsFromTime = function getSecondsFromTime(time) {
  var t = time.split(':');
  try {
    var s = t[2].split(',');
    if (s.length === 1) {
      s = t[2].split('.');
    }
    return parseFloat(t[0], 10) * 3600 + parseFloat(t[1], 10) * 60 + parseFloat(s[0], 10) + parseFloat(s[1], 10) / 1000;
  } catch (e) {
    return 0;
  }
};

var getScreenExtraField = function getScreenExtraField(intl) {
  return {
    name: 'parameters',
    type: 'parameters',
    label: intl.formatMessage({
      id: "8A8cuq",
      defaultMessage: [{
        "type": 0,
        "value": "Parameters"
      }]
    })
  };
};

function getScreenFieldsWithStates(definition) {
  var _ref = definition || {},
    _ref$fields = _ref.fields,
    screenFields = _ref$fields === void 0 ? null : _ref$fields,
    _ref$states = _ref.states,
    states = _ref$states === void 0 ? null : _ref$states;
  if (states === null) {
    return screenFields;
  }
  var extraFields = states.reduce(function (statesFields, current) {
    var _ref2 = current || {},
      id = _ref2.id,
      _ref2$fields = _ref2.fields,
      fields = _ref2$fields === void 0 ? [] : _ref2$fields,
      _ref2$repeatable = _ref2.repeatable,
      repeatable = _ref2$repeatable === void 0 ? false : _ref2$repeatable,
      _ref2$fieldName = _ref2.fieldName,
      fieldName = _ref2$fieldName === void 0 ? null : _ref2$fieldName,
      label = _ref2.label,
      _ref2$defaultValue = _ref2.defaultValue,
      defaultValue = _ref2$defaultValue === void 0 ? null : _ref2$defaultValue;
    return [].concat(_toConsumableArray(statesFields), _toConsumableArray(repeatable ? [{
      type: 'items',
      name: fieldName || id,
      label: label,
      defaultValue: defaultValue,
      stateId: id,
      itemsField: {
        label: label,
        type: 'fields',
        fields: fields
      }
    }] : []), _toConsumableArray(!repeatable && fieldName !== null ? [{
      type: 'fields',
      name: fieldName,
      stateId: id,
      fields: fields
    }] : []), _toConsumableArray(!repeatable && fieldName === null ? fields.map(function (it) {
      return _objectSpread(_objectSpread({}, it), {}, {
        stateId: id
      });
    }) : []));
  }, []);
  return [].concat(_toConsumableArray(extraFields), _toConsumableArray(screenFields));
}

function getShadowCoords(angle, distance) {
  var x = (Math.cos(angle) * distance).toFixed(3);
  var y = (Math.sin(angle) * distance).toFixed(3);
  return {
    x: x,
    y: y
  };
}

function getJustifyContent(horizontal) {
  if (horizontal === 'left') return 'flex-start';
  if (horizontal === 'middle') return 'center';
  if (horizontal === 'right') return 'flex-end';
  return null;
}
function getAlignItems(vertical) {
  if (vertical === 'top') return 'flex-start';
  if (vertical === 'middle') return 'center';
  if (vertical === 'bottom') return 'flex-end';
  return null;
}
var getStyleFromAlignment = function getStyleFromAlignment(value) {
  var invertAxis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var defaultAlignment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (value === null) {
    return null;
  }
  var _value$horizontal = value.horizontal,
    horizontal = _value$horizontal === void 0 ? null : _value$horizontal,
    _value$vertical = value.vertical,
    vertical = _value$vertical === void 0 ? null : _value$vertical;
  var justifyContent = getJustifyContent(horizontal);
  var alignItems = getAlignItems(vertical);
  if (invertAxis) {
    return {
      justifyContent: alignItems || defaultAlignment,
      alignItems: justifyContent || defaultAlignment
    };
  }
  return {
    justifyContent: justifyContent || defaultAlignment,
    alignItems: alignItems || alignItems
  };
};

var getStyleFromColor = function getStyleFromColor() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'backgroundColor';
  var overideAlpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var color = getColorAsString(value, overideAlpha);
  return color !== null ? _defineProperty({}, property, color) : null;
};

var getStyleFromBorder = function getStyleFromBorder(value) {
  if (value == null) {
    return null;
  }
  var _value$width = value.width,
    width = _value$width === void 0 ? null : _value$width,
    _value$style = value.style,
    borderStyle = _value$style === void 0 ? null : _value$style,
    _value$color = value.color,
    color = _value$color === void 0 ? null : _value$color;
  return _objectSpread(_objectSpread(_objectSpread({}, width !== null ? {
    borderWidth: width
  } : null), borderStyle !== null ? {
    borderStyle: borderStyle
  } : null), getStyleFromColor(color, 'borderColor'));
};

var getStyleFromShadow = function getStyleFromShadow(value) {
  if (value == null) {
    return null;
  }
  var _ref = value || {},
    _ref$shadowAngle = _ref.shadowAngle,
    shadowAngle = _ref$shadowAngle === void 0 ? null : _ref$shadowAngle,
    _ref$shadowDistance = _ref.shadowDistance,
    shadowDistance = _ref$shadowDistance === void 0 ? null : _ref$shadowDistance,
    _ref$shadowBlur = _ref.shadowBlur,
    shadowBlur = _ref$shadowBlur === void 0 ? null : _ref$shadowBlur,
    _ref$shadowColor = _ref.shadowColor,
    shadowColor = _ref$shadowColor === void 0 ? null : _ref$shadowColor;
  if (!shadowAngle) return null;
  var blur = shadowBlur || '0';
  var color = getColorAsString(shadowColor) || '#000000';
  var _getShadowCoords = getShadowCoords(shadowAngle, shadowDistance),
    x = _getShadowCoords.x,
    y = _getShadowCoords.y;
  var boxShadow = "".concat(x, "px ").concat(y, "px ").concat(blur, "px 0 ").concat(color);
  return {
    boxShadow: boxShadow
  };
};

// @todo hmm, gotta find a better way to handle this
var getStyleFromBox = function getStyleFromBox(value) {
  if (value === null) {
    return null;
  }
  var _value$backgroundColo = value.backgroundColor,
    backgroundColor = _value$backgroundColo === void 0 ? null : _value$backgroundColo,
    _value$borderRadius = value.borderRadius,
    borderRadius = _value$borderRadius === void 0 ? null : _value$borderRadius,
    _value$padding = value.padding,
    padding = _value$padding === void 0 ? null : _value$padding,
    _value$paddingTop = value.paddingTop,
    paddingTop = _value$paddingTop === void 0 ? null : _value$paddingTop,
    _value$paddingRight = value.paddingRight,
    paddingRight = _value$paddingRight === void 0 ? null : _value$paddingRight,
    _value$paddingBottom = value.paddingBottom,
    paddingBottom = _value$paddingBottom === void 0 ? null : _value$paddingBottom,
    _value$paddingLeft = value.paddingLeft,
    paddingLeft = _value$paddingLeft === void 0 ? null : _value$paddingLeft,
    _value$borderWidth = value.borderWidth,
    borderWidth = _value$borderWidth === void 0 ? null : _value$borderWidth,
    _value$borderStyle = value.borderStyle,
    borderStyle = _value$borderStyle === void 0 ? null : _value$borderStyle,
    _value$borderColor = value.borderColor,
    borderColor = _value$borderColor === void 0 ? null : _value$borderColor,
    _value$shadowAngle = value.shadowAngle,
    shadowAngle = _value$shadowAngle === void 0 ? null : _value$shadowAngle,
    _value$shadowDistance = value.shadowDistance,
    shadowDistance = _value$shadowDistance === void 0 ? null : _value$shadowDistance,
    _value$shadowBlur = value.shadowBlur,
    shadowBlur = _value$shadowBlur === void 0 ? null : _value$shadowBlur,
    _value$shadowColor = value.shadowColor,
    shadowColor = _value$shadowColor === void 0 ? null : _value$shadowColor;
  var border = {
    width: borderWidth,
    style: borderStyle,
    color: borderColor
  };
  var shadow = {
    shadowAngle: shadowAngle,
    shadowDistance: shadowDistance,
    shadowBlur: shadowBlur,
    shadowColor: shadowColor
  };
  var _ref = isObject(padding) ? padding : {
      padding: padding
    },
    _ref$top = _ref.top,
    paddingValueTop = _ref$top === void 0 ? null : _ref$top,
    _ref$right = _ref.right,
    paddingValueRight = _ref$right === void 0 ? null : _ref$right,
    _ref$bottom = _ref.bottom,
    paddingValueBottom = _ref$bottom === void 0 ? null : _ref$bottom,
    _ref$left = _ref.left,
    paddingValueLeft = _ref$left === void 0 ? null : _ref$left,
    _ref$padding = _ref.padding,
    paddingValue = _ref$padding === void 0 ? null : _ref$padding;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getStyleFromColor(backgroundColor, 'backgroundColor')), borderRadius !== null ? {
    borderRadius: borderRadius
  } : null), getStyleFromBorder(border)), getStyleFromShadow(shadow)), padding !== null || paddingValue !== null ? {
    padding: padding || paddingValue
  } : null), paddingTop !== null || paddingValueTop !== null ? {
    paddingTop: paddingTop || paddingValueTop
  } : null), paddingRight !== null || paddingValueRight != null ? {
    paddingRight: paddingRight || paddingValueRight
  } : null), paddingBottom !== null || paddingValueBottom !== null ? {
    paddingBottom: paddingBottom || paddingValueBottom
  } : null), paddingLeft !== null || paddingValueLeft !== null ? {
    paddingLeft: paddingLeft || paddingValueLeft
  } : null);
};

var getStyleFromContainer = function getStyleFromContainer(value) {
  if (value == null) {
    return null;
  }
  var _value$size = value.size,
    size = _value$size === void 0 ? {} : _value$size,
    _value$backgroundColo = value.backgroundColor,
    backgroundColor = _value$backgroundColo === void 0 ? null : _value$backgroundColo;
  var _size$width = size.width,
    width = _size$width === void 0 ? null : _size$width,
    _size$height = size.height,
    height = _size$height === void 0 ? null : _size$height;
  return _objectSpread(_objectSpread(_objectSpread({}, width ? {
    width: "".concat(width, "%")
  } : null), height ? {
    height: "".concat(height, "%")
  } : null), getStyleFromColor(backgroundColor, 'backgroundColor'));
};

var getStyleFromHighlight = function getStyleFromHighlight(value) {
  if (value == null) {
    return null;
  }
  var _value$textColor = value.textColor,
    textColor = _value$textColor === void 0 ? null : _value$textColor,
    _value$color = value.color,
    color = _value$color === void 0 ? null : _value$color;
  var colorString = color !== null ? getColorAsString(color) : null;
  var boxShadow = colorString !== null ? "0.05em 0px 0px ".concat(colorString, ", -0.05em 0px 0px ").concat(colorString) : null;
  return color !== null || textColor !== null ? _objectSpread(_objectSpread(_objectSpread({}, color !== null ? getStyleFromColor(color, 'backgroundColor') : null), textColor !== null ? getStyleFromColor(textColor, 'color') : null), color !== null ? {
    boxShadow: boxShadow,
    mozBoxShadow: boxShadow,
    msBoxShadow: boxShadow,
    webkitBoxShadow: boxShadow
  } : null) : null;
};

var getStyleFromImage = function getStyleFromImage(value) {
  if (value == null) {
    return null;
  }
  var _value$fit = value.fit,
    fit = _value$fit === void 0 ? {} : _value$fit,
    _value$backgroundColo = value.backgroundColor,
    backgroundColor = _value$backgroundColo === void 0 ? null : _value$backgroundColo;
  var _fit$size = fit.size,
    size = _fit$size === void 0 ? null : _fit$size,
    _fit$position = fit.position,
    position = _fit$position === void 0 ? {} : _fit$position;
  var _position$axisAlign = position.axisAlign,
    axisAlign = _position$axisAlign === void 0 ? null : _position$axisAlign,
    _position$crossAlign = position.crossAlign,
    crossAlign = _position$crossAlign === void 0 ? null : _position$crossAlign;
  return _objectSpread(_objectSpread(_objectSpread({}, size !== null ? {
    objectFit: size
  } : null), axisAlign !== null && crossAlign !== null ? {
    objectPosition: "".concat(axisAlign, " ").concat(crossAlign)
  } : null), getStyleFromColor(backgroundColor, 'backgroundColor'));
};

var getStyleFromLink = function getStyleFromLink(value) {
  if (value == null) {
    return null;
  }
  var _value$color = value.color,
    color = _value$color === void 0 ? null : _value$color,
    fontStyle = value.fontStyle;
  var _ref = fontStyle || {},
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? false : _ref$underline;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, color !== null ? getStyleFromColor(color, 'color') : null), italic ? {
    fontStyle: 'italic'
  } : null), bold ? {
    fontWeight: 'bold'
  } : null), underline ? {
    textDecoration: 'underline'
  } : null);
};

var getStyleFromText = function getStyleFromText(value) {
  if (value == null) {
    return null;
  }
  var _value$fontFamily = value.fontFamily,
    fontFamily = _value$fontFamily === void 0 ? null : _value$fontFamily,
    _value$fontSize = value.fontSize,
    fontSize = _value$fontSize === void 0 ? null : _value$fontSize,
    _value$fontStyle = value.fontStyle,
    fontStyle = _value$fontStyle === void 0 ? null : _value$fontStyle,
    _value$fontWeight = value.fontWeight,
    fontWeight = _value$fontWeight === void 0 ? null : _value$fontWeight,
    _value$lineHeight = value.lineHeight,
    lineHeight = _value$lineHeight === void 0 ? null : _value$lineHeight,
    _value$letterSpacing = value.letterSpacing,
    letterSpacing = _value$letterSpacing === void 0 ? null : _value$letterSpacing,
    _value$align = value.align,
    textAlign = _value$align === void 0 ? null : _value$align,
    _value$color = value.color,
    color = _value$color === void 0 ? null : _value$color;
  var _ref = fontStyle || {},
    _ref$italic = _ref.italic,
    italic = _ref$italic === void 0 ? false : _ref$italic,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? false : _ref$underline,
    _ref$transform = _ref.transform,
    textTransform = _ref$transform === void 0 ? null : _ref$transform,
    _ref$outline = _ref.outline,
    outline = _ref$outline === void 0 ? false : _ref$outline;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    fontFamily: getFontFamily(fontFamily)
  }, fontSize !== null ? {
    fontSize: fontSize
  } : null), italic ? {
    fontStyle: 'italic'
  } : null), bold ? {
    fontWeight: 'bold'
  } : null), fontWeight !== null ? {
    fontWeight: fontWeight
  } : null), underline ? {
    textDecoration: 'underline'
  } : null), textTransform !== null ? {
    textTransform: textTransform
  } : null), textAlign !== null ? {
    textAlign: textAlign
  } : null), lineHeight !== null ? {
    lineHeight: lineHeight
  } : null), letterSpacing !== null ? {
    letterSpacing: letterSpacing
  } : null), getStyleFromColor(color, 'color')), outline ? {
    WebkitTextStroke: "2px ".concat(getColorAsString(color, 'color')),
    color: 'transparent'
  } : null);
};

var getStyleFromMargin = function getStyleFromMargin(value) {
  if (value == null) {
    return null;
  }
  var _value$top = value.top,
    marginTop = _value$top === void 0 ? null : _value$top,
    _value$bottom = value.bottom,
    marginBottom = _value$bottom === void 0 ? null : _value$bottom;
  return _objectSpread(_objectSpread({}, marginTop !== null ? {
    marginTop: marginTop
  } : null), marginBottom !== null ? {
    marginBottom: marginBottom
  } : null);
};

var possibleMimes = ['video/webm', 'video/mp4', 'video/ogg', 'application/vnd.apple.mpegurl'];
var supportedMimes = null;
function getVideoSupportedMimes() {
  var mimes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : possibleMimes;
  if (supportedMimes === null) {
    var video = document.createElement('video');
    supportedMimes = mimes.filter(function (mime) {
      return video.canPlayType(mime) !== '';
    });
  }
  return supportedMimes;
}

var getLayoutParts = function getLayoutParts() {
  var layout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref = layout !== null && layout.indexOf('-') !== false ? layout.split('-') : [layout, null, null],
    _ref2 = _slicedToArray(_ref, 3),
    horizontal = _ref2[0],
    vertical = _ref2[1],
    suffix = _ref2[2];
  return {
    horizontal: horizontal,
    vertical: vertical,
    suffix: suffix
  };
};

var isHeaderFilled = function isHeaderFilled() {
  var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (header === null || typeof header === 'undefined') {
    return false;
  }
  var _ref = header || {},
    _ref$badge = _ref.badge,
    badge = _ref$badge === void 0 ? null : _ref$badge;
  var _ref2 = badge || {},
    _ref2$active = _ref2.active,
    badgeActive = _ref2$active === void 0 ? false : _ref2$active,
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? null : _ref2$label;
  var _ref3 = label || {},
    _ref3$body = _ref3.body,
    body = _ref3$body === void 0 ? null : _ref3$body;
  return badgeActive && body !== null;
};

var isFooterFilled = function isFooterFilled() {
  var footer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (footer === null || typeof footer === 'undefined') {
    return false;
  }
  var _ref = footer || {},
    _ref$callToAction = _ref.callToAction,
    callToAction = _ref$callToAction === void 0 ? null : _ref$callToAction;
  var _ref2 = callToAction || {},
    _ref2$active = _ref2.active,
    callToActionActive = _ref2$active === void 0 ? false : _ref2$active,
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? null : _ref2$label;
  var _ref3 = label || {},
    _ref3$body = _ref3.body,
    body = _ref3$body === void 0 ? null : _ref3$body;
  return callToActionActive && body !== null;
};

var isMessage = function isMessage(message) {
  return isObject(message) && typeof message.defaultMessage !== 'undefined';
};

var isIos = function isIos() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  navigator.userAgent.includes('Mac') && 'ontouchend' in document;
};

var isImageFilled = function isImageFilled(image) {
  if (image === null || typeof image === 'undefined') {
    return false;
  }
  var _ref = image || {},
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? null : _ref$media,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? null : _ref$url;
  return media !== null || url !== null;
};

var isTextFilled$1 = function isTextFilled(text) {
  if (text === null || typeof text === 'undefined') {
    return false;
  }
  var _ref = text || {},
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label;
  var _ref2 = label || {},
    _ref2$length = _ref2.length,
    length = _ref2$length === void 0 ? 0 : _ref2$length;
  return typeof length === 'number' && length > 0;
};

var isTextFilled = function isTextFilled(text) {
  if (text === null || typeof text === 'undefined') {
    return false;
  }
  var _ref = text || {},
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? null : _ref$body;
  var _ref2 = body || {},
    _ref2$length = _ref2.length,
    length = _ref2$length === void 0 ? 0 : _ref2$length;
  return typeof length === 'number' && length > 0;
};

var isValidUrl = function isValidUrl(string) {
  if (string === null || typeof string === 'undefined') {
    return false;
  }
  var url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
};

var createSchemaId = function createSchemaId(id) {
  return "https://schemas.micromag.ca/0.1/".concat(id, ".json");
};

var schemaId = function schemaId(str) {
  return createSchemaId(str.join('/'));
};

var _setValue = function setValue(value, keyParts, fieldValue) {
  var key = keyParts.shift();
  var isArray = key.match(/^[0-9]+$/) !== null;
  if (value !== null || fieldValue !== null) {
    if (isArray) {
      var index = parseInt(key, 10);
      // TODO: fix this with an explicit delete
      // instead on splicing out the element on null fieldValue
      // const newArrayValue =
      //     fieldValue !== null
      //         ? [
      //               ...value.slice(0, index),
      //               keyParts.length > 0
      //                   ? setValue(
      //                         value !== null ? value[index] || null : null,
      //                         keyParts,
      //                         fieldValue,
      //                     )
      //                   : fieldValue,
      //               ...value.slice(index + 1),
      //           ]
      //         : [...value.slice(0, index), ...value.slice(index + 1)];

      var newArrayValue = [].concat(_toConsumableArray(value.slice(0, index)), [keyParts.length > 0 ? _setValue(value !== null ? value[index] || null : null, keyParts, fieldValue) : fieldValue], _toConsumableArray(value.slice(index + 1)));
      return newArrayValue.length > 0 ? newArrayValue : null;
    }
    return _objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, keyParts.length > 0 ? _setValue(value !== null ? value[key] || null : null, keyParts, fieldValue) : fieldValue));
  }
  return null;
};

var slug = function slug(str) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var toSlug;
  if (separator === '-') {
    toSlug = kebabCase(str);
  } else {
    toSlug = snakeCase(str);
  }
  return slugify(toSlug, {
    lower: true
  });
};

var unique = function unique(arrArg) {
  return arrArg !== null ? arrArg.filter(function (elem, pos, arr) {
    return arr.indexOf(elem) === pos;
  }) : [];
};

var _validateFields = function validateFields(fields, value) {
  return fields.reduce(function (acc, field) {
    if (acc === true) {
      if (field.type === 'fields' && field.fields) {
        return _validateFields(field.fields, value);
      }
      var val = value && value[field.name] ? value[field.name] : false;
      return !(field.required && !val);
    }
    return acc;
  }, true);
};

var getContrastingColor = function getContrastingColor(backgroundColor) {
  var _ref = backgroundColor || {},
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'white' : _ref$color;
  if (tinycolor.equals(color, tinycolor('white'))) {
    return '#A13DFF';
  }
  if (tinycolor.equals(color, tinycolor('black'))) {
    return 'white';
  }
  return tinycolor(color).spin(30).toString();
};

export { addNonBreakingSpaces, convertStyleToString, copyToClipboard, createNullableOnChange, createUseEvent, easings, getColorAsString, getComponentFromName, getContrastingColor, getDeviceScreens, getDisplayName, _getFieldByName as getFieldByName, getFieldFromPath, getFileName, getFontFamily as getFontFamilyFromFont, getFooterProps, getGridLayoutName, largestRemainderRound as getLargestRemainderRound, getLayersFromBackground, getLayoutParts, getMediaFilesAsArray, getOptimalImageUrl, getScreenExtraField, getScreenFieldsWithStates, getSecondsFromTime, getShadowCoords, getStyleFromAlignment, getStyleFromBorder, getStyleFromBox, getStyleFromColor, getStyleFromContainer, getStyleFromHighlight, getStyleFromImage, getStyleFromLink, getStyleFromMargin, getStyleFromText, getVideoSupportedMimes, isFooterFilled, isHeaderFilled, isImageFilled, isIos, isTextFilled$1 as isLabelFilled, isMessage, isTextFilled, isValidUrl, schemaId, _setValue as setFieldValue, slug, unique, _validateFields as validateFields };
